import { Users, ExternalLink } from "lucide-react";
import { CA } from "../config";

const SOLSCAN_HOLDERS = `https://solscan.io/token/${CA}#holders`;

export default function HoldersCard() {
  return (
    <div
      data-testid="holders-card"
      className="w-full max-w-xs rounded-2xl border border-white/10 bg-[#0F141C]/80 p-4 shadow-[0_8px_32px_rgba(0,0,0,0.4)] backdrop-blur-xl"
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Users className="h-4 w-4 text-[#00F5D4]" />
          <span className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-slate-400">Top Holders</span>
        </div>
        <span className="flex items-center gap-1.5 font-mono-x text-[9px] uppercase tracking-[0.2em] text-[#00E676]">
          <span className="animate-glow-pulse inline-block h-1.5 w-1.5 rounded-full bg-[#00E676]" />
          Live
        </span>
      </div>

      <p className="mb-3 font-mono-x text-xs leading-relaxed text-slate-500">
        Track the biggest $SOLMAS bags in real time on the explorer.
      </p>
      <a
        data-testid="holders-solscan-link"
        href={SOLSCAN_HOLDERS}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-between gap-2 rounded-xl border border-[#00F5D4]/20 bg-[#00F5D4]/5 px-4 py-2.5 font-mono-x text-xs text-[#00F5D4] transition-all duration-200 hover:border-[#00F5D4]/50 hover:bg-[#00F5D4]/10"
      >
        View live holders on Solscan
        <ExternalLink className="h-3.5 w-3.5 shrink-0" />
      </a>
    </div>
  );
}
